import dayjs from '@/libs/dayjs';
import { formatDate } from './dateUtil';

export const getDetailedDates = (
  datetimes: DatetimeDto[],
  format = 'YYYY年MM月DD日(ddd)'
) => {
  if (datetimes.length === 0) {
    return [];
  }
  // 連続する日付をまとめる
  const borders: number[] = [];
  datetimes.forEach((d, i) => {
    if (i === 0) {
      borders.push(i);
      return;
    }
    const prevDate = dayjs(datetimes[i - 1].startsAt);
    if (!prevDate.add(1, 'day').isSame(d.startsAt, 'day')) {
      borders.push(i - 1);
      borders.push(i);
    }
  });
  borders.push(datetimes.length - 1);
  const datetimeStrArray: string[] = [];
  for (let i = 0; i < borders.length / 2; i++) {
    if (borders[i * 2] === borders[i * 2 + 1]) {
      datetimeStrArray.push(
        formatDate(datetimes[borders[i * 2]].startsAt, format)
      );
    } else {
      datetimeStrArray.push(
        `${formatDate(datetimes[borders[i * 2]].startsAt, format)}〜${formatDate(
          datetimes[borders[i * 2 + 1]].startsAt,
          format
        )}`
      );
    }
  }
  return datetimeStrArray;
};

export const getSimpleDate = (
  startsAt: ImEventDto['startsAt'],
  endsAt: ImEventDto['endsAt'],
  format = 'YYYY年M月D日(ddd)'
) => {
  const start = formatDate(startsAt, format);
  const end = formatDate(endsAt, format);
  if (start === end) {
    return start;
  }
  return `${start}〜${end}`;
};
